import PriceRecalculationTrigger from './PriceRecalculationTrigger';

export default PriceRecalculationTrigger;
